import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';

import EvaluateProducts from 'pages/CoreMattressPage/EvaluateProducts/EvaluateProducts';
import localize from 'components/Localize/Localize';
import RatingLogos from 'components/RatingLogos/RatingLogos';
import ValueProp from 'components/ValueProp/ValueProp';

import styles from './TirelessImprovement.css';
import translations from './translations';

class TirelessImprovement extends React.Component {
  render() {
    return (
      <section>
        <ValueProp
          imageConfig={this.props.imageConfig}
          imageContainerStyles={styles[`image-container`]}
          imagePosition="left"
          imageStyles={styles[`image`]}
          keyName="mattress.props.engineering"
          t={this.props.t.valueProp}
        >
          <RatingLogos
            casperReviewsAvgRating={this.props.casperReviewsAvgRating}
            casperReviewsTotalCount={this.props.casperReviewsTotalCount}
          />
        </ValueProp>
        <EvaluateProducts />
      </section>
    );
  }
}

TirelessImprovement.propTypes = {
  casperReviewsAvgRating: PropTypes.number.isRequired,
  casperReviewsTotalCount: PropTypes.number.isRequired,
  imageConfig: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  t: PropTypes.shape({
    valueProp: PropTypes.shape({
      content: PropTypes.string.isRequired,
      heading: PropTypes.string.isRequired,
      imageDescription: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  casperReviewsAvgRating: _get(state, `product.product.ratings-summary.avg-rating`),
  casperReviewsTotalCount: _get(state, `product.product.ratings-summary.total-count`),
});

export default connect(mapStateToProps)(localize(TirelessImprovement, translations));
